<template>
  <div class="nav-main">
    <!-- <canvas id="nav-canvas"
            style="position: absolute; z-index: -1; left: 0;"></canvas> -->
    <span v-for="(item,index) in navs"
          :key="index"
          class="nav-span">
      <a class="nav-link"
         :class="{ 'nav-active': index === activeIndex }"
         @click="toggleNav(item,index)">
        <i :class="item.icon"></i>
        {{ item.name }}
      </a>
    </span>
  </div>
</template>

<script>
// import { NavCanvas } from "./nav-canvas";
// import {roleMenuList} from '@/page/system/api/role';
import {getUserPermissionList} from '@/page/system/api/user';
export default {
  data () {
    return {
      nc: null,
      navs: [{
        icon: 'el-icon-menu',
        name: '大屏管理',
        path: '/'
      }, {
        icon: 'el-icon-location-information',
        name: '地图管理',
        path: '/map'
      }, {
        icon: 'el-icon-folder-opened',
        name: '分类管理',
        path: '/category'
      }, {
        icon: 'el-icon-set-up',
        name: '数据源管理',
        path: '/db'
      }, {
        icon: 'el-icon-suitcase',
        name: '数据集管理',
        path: '/record'
      }, {
        icon: 'el-icon-eleme',
        name: '组件库',
        path: '/components'
      },{
        icon: 'el-icon-user',
        name: '模板列表',
        path: '/templetManage'
      },
      {
        icon: 'el-icon-user',
        name: '模型管理',
        path: '/modelManage'
      },{
        icon: 'el-icon-user',
        name: '系统管理',
        path: '/system'
      }],
      activeNav: null,
      activeIndex: 0,
    }
  },
  created() {
    this.userinfo()
  },
  mounted () {
    
    // this.navs = this.navs.filter((ele, index) => {
    //   return this.$website.tabsList.includes(index)
    // })
    // console.log('111', 111, this.$route.path)
    // let index = this.navs.findIndex(ele => ele.path === this.$route.path)
    // this.activeNav = this.navs[index];
    // this.activeIndex = index
    // this.nc = new NavCanvas("nav-canvas", ".nav-main .nav-span", this.activeIndex);
  },
  methods: {
    userinfo(){
      getUserPermissionList().then(res => {
        if(res.data.data.length > 0) {
          this.navs = res.data.data
          // console.log('this.navs', this.navs)
          // var indexs = this.$route.path.lastIndexOf('/')
    // var resolve = str.substring(0, indexs);
          let index = this.navs.findIndex(ele => {
            if(ele.name === this.$route.meta.title) {
               return ele;
            }
            if(ele.childs) {
              return ele;
            }
          })
          // console.log('index', index)
          this.activeNav = this.navs[index];
          // console.log('activeNav', this.activeNav)
          this.activeIndex = index
          // this.nc = new NavCanvas("nav-canvas", ".nav-main .nav-span", this.activeIndex);
        }
    //     if(res.data.user.userName === 'admin') {
    //       // var indexs = this.$route.path.lastIndexOf('/')
    //       // console.log('index', indexs)
    // // var resolve = this.$route.path.substring(0, indexs);
    //       let index = this.navs.findIndex(ele => ele.name === this.$route.meta.title)
    //       // let index = this.navs.findIndex(ele => ele.path === resolve)
    //       this.activeNav = this.navs[index];
    //       this.activeIndex = index
    //       // this.nc = new NavCanvas("nav-canvas", ".nav-main .nav-span", this.activeIndex);
    //     }
      })
    },
    toggleNav (nav, index) {
      this.activeNav = nav;
      this.activeIndex = index;
      // this.nc.toggle(this.activeIndex)
      this.$emit('change', nav, index)
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-main {
  z-index: 1024;
  margin-top: 2px;
  // position: absolute;
  display: flex;
  width: 100%;
  user-select: none;
  height: 40px;
  padding: 0 20px;
  .nav-span {
    margin-right: 10px;
    .nav-link {
      transition: color 0.2s;
      text-decoration: none !important;
      display: block;
      color: #b9c2cc;
      width: auto;
      line-height: 40px;
      font-size: 14px;
      text-align: left;
      cursor: pointer;
      padding: 0 30px;
      text-align: center;
      background: #102A9A;
      position: relative;
      &.nav-active,
      &:hover {
        background: #2189FF;
        color: #fff !important;
        ::after {
          position: absolute;
          left: 0;
          bottom: -1px;
          content: '';
          height: 2px;
          width: 100%;
          background: #01D8FF;
          border: 0px solid #01D8FF;
        }
      }
    }
  }
}
</style>